import React from 'react';

const Icon = ({ width = '49', height = '48', fill = 'white', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 49 48" fill="none" {...other}>
            <g clipPath="url(#a)" stroke={fill} strokeWidth="2.25">
                <path
                    clipRule="evenodd"
                    d="M24.333 4.5c3.728 0 7.103 1.511 9.546 3.954A13.458 13.458 0 0 1 37.833 18c0 3.728-1.51 7.103-3.954 9.546a13.457 13.457 0 0 1-9.546 3.954 13.457 13.457 0 0 1-9.546-3.954A13.458 13.458 0 0 1 10.833 18c0-3.728 1.511-7.103 3.954-9.546A13.458 13.458 0 0 1 24.333 4.5Z"
                />

                <path
                    clipRule="evenodd"
                    d="M23.863 14.811c.88 0 1.677.357 2.254.934.577.577.933 1.373.933 2.254 0 .88-.356 1.677-.933 2.254a3.178 3.178 0 0 1-2.254.933c-.88 0-1.677-.357-2.254-.933a3.178 3.178 0 0 1-.934-2.254c0-.88.357-1.677.934-2.254a3.178 3.178 0 0 1 2.254-.934Z"
                />

                <path d="M24.97 14.34c.937-3.603 1.928-5.64 2.82-5.39 1.338.377 3.358 1.663 3.143 3.338-.181 1.418-1.865 3.433-3.916 5.14m-.33 2.499c3.138 2.005 4.77 3.577 4.255 4.348-.772 1.156-2.618 2.68-4.145 1.958-1.293-.61-2.689-2.834-3.68-5.313m-2.814-1.707c-3.442 1.42-5.666 1.856-6.002.992-.504-1.295-.693-3.682.774-4.52 1.241-.708 3.864-.576 6.462.035m.546 15.03-1.43 7.703m5.93-7.703 1.47 7.628" />

                <path d="M33.333 34.5v2.852" strokeLinecap="round" />

                <rect x="10.458" y="38.625" width="27.75" height="3.75" rx="1.875" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill={fill} d="M.333 0h48v48h-48z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
